import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useState } from 'react';
import styled, { css, useTheme } from 'styled-components';
import { Headline, LinkAdapter } from '@miro-site/components_utils';
import { Box, Card, Section, Text, Grid, ArrowRight } from '@miro-site/core';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ArrowIcon = styled(ArrowRight).attrs({
  $styles: {
    width: [12, 15],
    height: [10, 12]
  }
}).withConfig({
  displayName: "Resources__ArrowIcon",
  componentId: "sc-16io7rv-0"
})(["position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);"]);
var ArrowContainer = styled(Box).attrs(function (_ref) {
  var theme = _ref.theme;
  return {
    $styles: {
      width: theme.spaces.xl,
      height: theme.spaces.xl,
      right: theme.spaces.md,
      bottom: theme.spaces.md
    }
  };
}).withConfig({
  displayName: "Resources__ArrowContainer",
  componentId: "sc-16io7rv-1"
})(["background:", ";border-radius:50%;position:absolute;transition:background ", ";transform:rotate(-45deg);"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.primaryBlue;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.animation.transitionDuration;
});
var Item = styled(Card).attrs({
  $pb: [80]
}).withConfig({
  displayName: "Resources__Item",
  componentId: "sc-16io7rv-2"
})(["display:block;background:", ";height:100%;position:relative;overflow:hidden;cursor:pointer;&:hover{", "{background:", ";}}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.primaryWhite;
}, ArrowContainer, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.primaryBlueHover;
});
var ItemHeadline = styled(Headline).attrs({
  size: 'tiny',
  tag: 'h3'
}).withConfig({
  displayName: "Resources__ItemHeadline",
  componentId: "sc-16io7rv-3"
})([""]);
var SourceContainer = styled(Box).withConfig({
  displayName: "Resources__SourceContainer",
  componentId: "sc-16io7rv-4"
})(["& > ", "{font-family:", ";font-feature-settings:'ss03';color:", ";}& + ", "{", "}"], Text, function (props) {
  return props.theme.fonts.formular;
}, function (props) {
  return props.theme.colors.greyish;
}, ItemHeadline, function (props) {
  return css(["", ""], props.theme.normalizeStyles({
    marginTop: 8
  }));
});

var Resources = function Resources(_ref6) {
  var headline = _ref6.headline,
      items = _ref6.items,
      sectionId = _ref6.sectionId;
  var theme = useTheme();

  var _useState = useState(-1),
      focusedElement = _useState[0],
      setFocusedElement = _useState[1];

  var handleItemClick = function handleItemClick(href, e) {
    var selection = document.getSelection();

    if (selection !== null && selection !== void 0 && selection.toString()) {
      return;
    }

    e.preventDefault();
    window.open(href, '_blank');
  };

  return /*#__PURE__*/_jsx(Section, {
    id: sectionId,
    "data-place": "Resources",
    type: "large",
    children: /*#__PURE__*/_jsxs(Box, {
      $styles: {
        margin: 'auto',
        position: 'relative',
        maxWidth: [null, 1120]
      },
      $py: [0, null],
      $px: [20, null],
      children: [headline && /*#__PURE__*/_jsx(Headline, _objectSpread(_objectSpread({}, headline), {}, {
        size: headline.size || 'mid',
        tag: headline.tag || 'h2',
        align: headline.align || 'center'
      })), (items === null || items === void 0 ? void 0 : items.length) && /*#__PURE__*/_jsx(Box, {
        $mt: theme.spaces.xl,
        children: /*#__PURE__*/_jsx(Grid, {
          columns: items.length,
          align: "stretch",
          children: items.map(function (item, index) {
            var _item$headline, _item$link;

            var linkText = ((_item$headline = item.headline) === null || _item$headline === void 0 ? void 0 : _item$headline.text) || ((_item$link = item.link) === null || _item$link === void 0 ? void 0 : _item$link.text);

            if (typeof linkText === 'string') {
              linkText = linkText.trim();
            }

            var link = /*#__PURE__*/_jsx(LinkAdapter, _objectSpread(_objectSpread({}, item.link), {}, {
              text: linkText,
              href: item.link.href,
              simple_link: true,
              onClick: function onClick(e) {
                return e.preventDefault();
              },
              onFocus: function onFocus() {
                setFocusedElement(index);
              },
              onBlur: function onBlur() {
                return setFocusedElement(-1);
              }
            }));

            return /*#__PURE__*/_jsxs(Item, {
              $mt: index >= 1 ? [16, null] : null,
              $isFocused: focusedElement == index,
              onClick: function onClick(e) {
                return handleItemClick(item.link.href, e);
              },
              children: [/*#__PURE__*/_jsxs(Box, {
                $pt: theme.spaces.lg,
                $px: theme.spaces.lg,
                $pb: 0,
                children: [item.source && /*#__PURE__*/_jsx(SourceContainer, {
                  children: /*#__PURE__*/_jsx(Text, {
                    as: "div",
                    $variant: "p1",
                    children: item.source
                  })
                }), item.headline && /*#__PURE__*/_jsx(ItemHeadline, _objectSpread(_objectSpread({}, item.headline), {}, {
                  text: link
                }))]
              }), /*#__PURE__*/_jsx(ArrowContainer, {
                children: /*#__PURE__*/_jsx(ArrowIcon, {})
              })]
            }, index);
          })
        })
      })]
    })
  });
};

export default Resources;